export default function Reviews() {
  const testimonials = [
    {
      name: '追瓜小达人', role: '吃瓜新手', icon: 'ri-emotion-happy-line',
      text: '以前总是一觉醒来瓜都凉了，现在每天早上先看这里的热度榜，五分钟就能补完全部重点，再也不怕跟不上话题了。',
    },
    {
      name: '深扒老玩家', role: '情报控', icon: 'ri-vip-crown-line',
      text: '最打动我的是它的可信度分级。路透和实锤标得清清楚楚，速度快还能不误导人，这点很难得，我几乎当成了主力情报源。',
    },
    {
      name: '内容运营', role: '行业从业者', icon: 'ri-briefcase-line',
      text: '做热点选题必备。平台速度排行帮我看清楚流量首发窗口，几个平台的传播对比让选题判断有了数据支撑，效率提升很明显。',
    },
  ];

  return (
    <section id="reviews" className="mx-auto max-w-7xl scroll-mt-20 px-4 py-14 md:px-6 md:py-20">
      <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-800">
            <i className="ri-chat-3-line" />
            COMMUNITY
          </span>
          <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-4xl">追瓜群众的声音</h2>
          <p className="mt-2 text-sm text-foreground-600 md:text-base">来自真实使用者的反馈，是我们持续抢先的动力。</p>
        </div>
      </div>

      <div className="mt-8 grid gap-5 md:grid-cols-3">
        {testimonials.map((t) => (
          <figure key={t.name} className="flex flex-col rounded-2xl border border-background-200 bg-background-50 p-5 transition hover:border-accent-300">
            <div className="flex items-center gap-1 text-accent-500">
              {Array.from({ length: 5 }).map((_, i) => (
                <i key={i} className="ri-star-fill text-sm" />
              ))}
            </div>
            <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">“{t.text}”</blockquote>
            <figcaption className="mt-5 flex items-center gap-3 border-t border-background-100 pt-4">
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-100 text-primary-600">
                <i className={`${t.icon} text-lg`} />
              </span>
              <div>
                <p className="text-sm font-bold text-foreground-950">{t.name}</p>
                <p className="text-xs text-foreground-500">{t.role}</p>
              </div>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}